import React from 'react'
 import './AboutUSstyle.css'
const AboutUS = () => {
  return (
    <div className='about-container'>
        <h1>Our History</h1>
        <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Impedit exercitationem fugiat sit, deleniti quas commodi molestias alias ad tenetur voluptate ratione quaerat pariatur dolore facere cum, eos dolores voluptatibus doloremque optio adipisci odit laborum. Eaque quod, aperiam repellat neque dolor, libero aut asperiores molestiae ullam maiores reprehenderit, nam recusandae necessitatibus fugit facere ad laboriosam id.</p>

        <h1>Our Mission</h1>
        <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Impedit exercitationem fugiat sit, deleniti quas commodi molestias alias ad tenetur voluptate ratione quaerat pariatur dolore facere cum, eos dolores voluptatibus doloremque optio adipisci odit laborum. Eaque quod, aperiam repellat neque dolor, libero aut asperiores molestiae ullam maiores reprehenderit, nam recusandae necessitatibus fugit facere ad laboriosam id.</p>
      
        <h1>Our Vision</h1>
        <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Impedit exercitationem fugiat sit, deleniti quas commodi molestias alias ad tenetur voluptate ratione quaerat pariatur dolore facere cum, eos dolores voluptatibus doloremque optio adipisci odit laborum. Eaque quod, aperiam repellat neque dolor, libero aut asperiores molestiae ullam maiores reprehenderit, nam recusandae necessitatibus fugit facere ad laboriosam id.</p>
      
    </div>
  )
}

export default AboutUS